export const messages = {
  en: {
    listRoomRenovationRecordDetails: {
      title: 'Renovation Record',
      page: {
        title: 'Renovation Record Media',
        subtitle: 'Images and videos uploaded for the decoration tracking record',
        empty: 'No media files found for this record',
        loadFailed: 'Failed to load renovation record details, please retry',
        tip: 'Click the thumbnail to preview the original image'
      },
      back: 'Back',
      room: 'Room',
      media: 'Media',
      originalMedia: 'Original Media',
      createTime: 'Create Time',
      fetchError: 'Failed to fetch renovation record details'
    }
  },
  zh: {
    listRoomRenovationRecordDetails: {
      title: '装修记录',
      page: {
        title: '装修记录明细',
        subtitle: '装修跟踪记录上传的图片与视频',
        empty: '该记录暂无图片或视频',
        loadFailed: '装修记录详情加载失败，请重试',
        tip: '点击缩略图可查看原图'
      },
      back: '返回',
      room: '房屋',
      media: '图片/视频',
      originalMedia: '原始图片/视频',
      createTime: '创建时间',
      fetchError: '获取装修记录详情失败'
    }
  }
}